module.exports = __webpack_public_path__ + "media/kate_rage_genius.d8a9f4a6.mp3";